export default __webpack_public_path__ + "static/media/CHARGELOGO.f830825f.png";